import { authConfig } from "../apiConfig";

// for get all completed invoice reports
export const get_invoice_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`Invoicesreport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};